import React, { Component } from 'react';
import { translate } from 'react-translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEqual } from 'lodash';
import {default as ModalDefault} from '@components/Modal';
import InputDefault from '@components/InputDefault/InputDefault';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IS_LOADING } from '@redux/loading/types';
import { GET_STEP } from '@redux/easyaccess/types';
import { CHANGE_LANGUAGE } from '@redux/translates/types';
import images from '@images';
import EmailStep from './EmailStep';
import PageSteps from './PageSteps';
import AccountSteps from './AccountSteps';
import CheckSteps from './CheckSteps';
import StepsCompleted from './CheckSteps/StepsCompleted';
import Stepper from './Stepper';
import { GET_COMPANY_INFO } from '../../redux/easyaccess/types';
import * as S from './styles';

class EasyAccess extends Component {
  state = {
    invitationToken: null,
    hasInvitationToken: null,
    step: 'not_started',
    fb: null,
    tokenValue: '',
    facebookToken: null,
    facebookEncryptedToken: null,
    email: null,
    name: null,
    showSharedBudgetMessage: false,
    showModal: false,
    badPermission: false,
  };

  constructor(props) {
    super(props);
    this.setState = this.setState.bind(this);
    this.getStep = this.getStep.bind(this);
    this.statusChangeCallback = this.statusChangeCallback.bind(this);
  }

  hasInvitationToken = () => {
    const params = window.location.search
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams(window.location.href.split('?')[1]);
    const invitationToken = params.get('invitation_token');
    return invitationToken ? invitationToken.split('#')[0] : false;
  };

  componentDidMount() {
    const {
      props: { dispatch },
    } = this;

    const token = this.hasInvitationToken();

    if (!token) {
      this.setState({
        hasInvitationToken: false,
      });
    } else {
      this.setState({
        invitationToken: token,
        hasInvitationToken: true,
      });

      window.statusChangeCallback = this.statusChangeCallback;
      window.checkLoginState = this.checkLoginState;

      const fbDiv =
        '<div class="fb-login-button" ' +
        'data-size="large" data-button-type="continue_with"' +
        'data-auto-logout-link="false" ' +
        'data-use-continue-as="true"' +
        'scope="public_profile,email"' +
        'onlogin="checkLoginState"></div>';

      this.setState({
        fb: fbDiv,
      });

      const language = 'pt-BR';
      dispatch({
        type: CHANGE_LANGUAGE.SUCCESS,
        language,
      });

      dispatch({
        type: GET_COMPANY_INFO.REQUEST,
        version: '1.0',
        invitationToken: token,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      props: {
        dispatch,
        authenticationReducer: { subDomainLoading },
        easyAccessReducer: { step },
      },
    } = this;

    if (prevProps.easyAccessReducer.step.isLoading !== step.isLoading) {
      dispatch({
        type: IS_LOADING.SUCCESS,
        isLoading: step.isLoading,
      });
    }

    if (prevProps.authenticationReducer.subDomainLoading !== subDomainLoading) {
      dispatch({
        type: IS_LOADING.SUCCESS,
        isLoading: subDomainLoading,
      });
    }

    if (
      !isEqual(prevProps.easyAccessReducer.step.current_step, step.current_step) &&
      !step.isLoading
    ) {
      this.setState({
        step: step.current_step,
        // step: 'show_penfing_requests',
      });
    }

    if (
      !isEqual(
        prevProps.easyAccessReducer.step.facebook_encrypted_token,
        step.facebook_encrypted_token
      ) &&
      !step.isLoading
    ) {
      this.setState({
        facebookEncryptedToken: step.facebook_encrypted_token,
      });
    }

    if (!isEqual(prevProps.easyAccessReducer.step.email, step.email) && !step.isLoading) {
      this.setState({
        email: step.email,
      });
    }

    if (!isEqual(prevProps.easyAccessReducer.step.name, step.name) && !step.isLoading) {
      this.setState({
        name: step.name,
      });
    }

    if (
      !isEqual(
        prevProps.easyAccessReducer.step.has_shared_budget_ad_account,
        step.has_shared_budget_ad_account
      ) &&
      !step.isLoading
    ) {
      this.setState({
        showSharedBudgetMessage: step.has_shared_budget_ad_account,
      });
    }
  }

  statusChangeCallback = (response) => {
    if (response.status === 'connected') {
      const userToken = response.authResponse.accessToken;

      this.setState(
        {
          facebookAccessToken: userToken,
        },
        () => {
          this.getStep();
        }
      );
    } else {
      window.FB.login(
        (response) => {
          if (
            response.authResponse &&
            response.authResponse.grantedScopes.includes('ads_management')
          ) {
            this.setState({
              badPermission: false,
            });

            let userToken = '';

            if (
              process.env.NODE_ENV === 'development' ||
              process.env.REACT_APP_BETA_GD === 'true'
            ) {
              userToken = this.state.tokenValue;
              // userToken = "EAAGkZCPOvWJoBAGY9cIZAMUWS54KLkJ1ZBjgXZB5AkOTT4tUdjPS8aZCsLY5JFd70Fsj7CTUrd5v469GcTS4HnZBmpNTLHz6iZCabA9VWZBcBF4aZBIU1HOYRe0mkkn3ZAo4x2gy5bBRMznxIlARw5Y2Xr18XytlClOv7vxuZA52Gpgbc0I7U9YmfoT7IqNxSkSHODCGNXIc3Rw5QlnbOZBUUe79mV0SmqJm4CMZD"
            } else {
              userToken = response.authResponse.accessToken;
            }

            this.setState(
              {
                facebookAccessToken: userToken,
              },
              () => {
                this.getStep();
              }
            );
          } else {
            this.setState({
              badPermission: true,
            });
          }
        },
        { scope: 'public_profile,email,ads_management' }
      );
    }
  };

  getStep = () => {
    const {
      state,
      props: { dispatch },
    } = this;

    dispatch({
      type: GET_STEP.REQUEST,
      version: '1.0',
      facebookAccessToken: state.facebookAccessToken,
      invitationToken: state.invitationToken,
    });
  };

  checkLoginState = () => {
    window.FB.getLoginStatus((response) => {
      this.statusChangeCallback(response);
    });
  };

  handler = () => {
    this.setState({
      showSharedBudgetMessage: false,
    });
  };

  onChangeTokenValue = (event) => {
    this.setState({ tokenValue: event.target.value });
  };

  render() {
    const {
      state,
      props: {
        t,
        authenticationReducer: { subDomain },
        easyAccessReducer: { companyInfo },
      },
    } = this;

    return (
      <S.EasyAccessWrapper>
        <ModalDefault
          visible={state.showModal}
          effect="fadeInDown"
          width={530}
          title={t('ATENTION')}
          onClickAway={() => this.setState({ showModal: false })}
          cancelButton={() => this.setState({ showModal: false })}
          cancelButtonText={t('CANCEL')}
          confirmButton={() =>
            window.open(
              'https://www.facebook.com/pages/create/?ref_type=pages_browser',
              '_blank'
            ) && this.setState({ showModal: false })
          }
          confirmButtonText={t('CONFIRM')}
          mobileFullScreen
          iconClose={['fal', 'times']}
        >
          <S.ModalContentWrapper>
            Você será direcionado para criar sua página no Facebook. Assim que terminar, retorne
            aqui.
          </S.ModalContentWrapper>
        </ModalDefault>

        <S.StepperWrapper>
          {(state.step === 'set_page_scoped_token' || state.step === 'set_page') && (
            <Stepper position="1" mode="half" />
          )}
          {state.step === 'show_pending_requests' && state.showSharedBudgetMessage && (
            <Stepper position="2" mode="half" />
          )}
          {state.step === 'show_pending_requests' && !state.showSharedBudgetMessage && (
            <Stepper position="3" mode="half" />
          )}
          {(state.step === 'completed' ||
            state.step === 'finished' ||
            state.step === 'waiting_platform_setup' ||
            state.step === 'pending_platform_invitation') && <Stepper position="3" mode="full" />}
        </S.StepperWrapper>
        <S.LogoWrapper>
          {!!subDomain && !!subDomain.picture_url && !!subDomain.name ? (
            <img src={subDomain.picture_url} alt={subDomain.name} title={subDomain.name} />
          ) : (
            <img src={images.logo} alt={t('ALT_LOGO')} title={t('ALT_LOGO')} />
          )}
        </S.LogoWrapper>
        <S.EasyAccessInnerWrapper>
          <S.EasyAccessWrapperCard>
            {state.hasInvitationToken === false && <div>{t('NOT_INVITED')}</div>}
            {state.hasInvitationToken !== false && (
              <S.CardWrapper>
                <>
                  {state.step === 'not_started' && (
                    <S.LoginWrapper>
                      {process.env.REACT_APP_BETA_GD === 'true' && (
                        <>
                          <InputDefault
                            type="text"
                            id="search"
                            name="search"
                            placeholder="Facebook Token"
                            onChange={this.onChangeTokenValue}
                            value={state.tokenValue}
                            fontSize="px16"
                            icon={['fab', 'facebook']}
                            block
                          />
                        </>
                      )}
                      {state.badPermission && (
                        <S.ErrorDiv>
                          {' '}
                          <FontAwesomeIcon
                            icon={['fal', 'exclamation-triangle']}
                          /> &nbsp;&nbsp; {t('PERMISSION-ERROR')}
                        </S.ErrorDiv>
                      )}
                      <S.WelcomeText>{t('WELCOME-TEXT')}</S.WelcomeText>
                      <S.PageMessage>
                        {t('PAGE-MESSAGE')}
                        <S.ClickHere onClick={() => this.setState({ showModal: true })}>
                          {t('CLICK-HERE')}
                        </S.ClickHere>
                        {t('PAGE-MESSAGE-2')}
                      </S.PageMessage>
                      <S.FBWrapper dangerouslySetInnerHTML={{ __html: state.fb }} />
                      <S.DescriptionText>
                        {t('LOGIN-TEXT')} {companyInfo.name}.
                      </S.DescriptionText>
                    </S.LoginWrapper>
                  )}
                  {state.step === 'set_email' && (
                    <EmailStep email={state.email} token={state.facebookEncryptedToken} />
                  )}
                  {(state.step === 'set_page_scoped_token' || state.step === 'set_page') && (
                    <PageSteps
                      step={state.step}
                      token={state.facebookEncryptedToken}
                      email={state.email}
                      name={state.name}
                    />
                  )}
                  {state.step === 'show_pending_requests' && state.showSharedBudgetMessage && (
                    <AccountSteps
                      sharedBudget={state.showSharedBudgetMessage}
                      handler={this.handler}
                    />
                  )}
                  {state.step === 'show_pending_requests' && !state.showSharedBudgetMessage && (
                    <CheckSteps token={state.facebookEncryptedToken} />
                  )}
                  {(state.step === 'completed' ||
                    state.step === 'finished' ||
                    state.step === 'waiting_platform_setup' ||
                    state.step === 'pending_platform_invitation') && <StepsCompleted />}
                </>
              </S.CardWrapper>
            )}
          </S.EasyAccessWrapperCard>
        </S.EasyAccessInnerWrapper>
      </S.EasyAccessWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticationReducer: state.authenticationReducer,
    easyAccessReducer: state.easyAccessReducer,
  };
}

export default withRouter(connect(mapStateToProps)(translate('EasyAccess')(EasyAccess)));
